import React, { useRef, useState } from 'react';
import { Table } from './Table';
import { Toast } from 'primereact/toast';
import { IPermissionProps } from '../../../models/Login';

export const PrimeVendorInvoice = (permissions: IPermissionProps) => {
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);
    return (
        <>
            <Table permissions={permissions} toast={toast} reload={reload} setReload={setReload} />
            <Toast ref={toast} />
        </>
    );
}